import * as React from "react"
import type { SVGProps } from "react"
const SvgSettingsWrench = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 15.86a5.8 5.8 0 0 1-4.25-1.75A5.8 5.8 0 0 1 3 9.86q0-.5.08-1t.27-.95a1 1 0 0 1 .31-.38 1 1 0 0 1 .42-.17 1 1 0 0 1 .9.27l2.62 2.63 1.8-1.8-2.62-2.63a1 1 0 0 1-.28-.9 1 1 0 0 1 .18-.41 1 1 0 0 1 .37-.31Q7.5 4 8 3.93t1-.07q2.5 0 4.25 1.75a5.8 5.8 0 0 1 1.65 5.34q-.1.5-.3 1l5.05 5q.73.73.73 1.78c0 1.05-.25 1.3-.73 1.78q-.72.72-1.77.72c-1.05 0-1.3-.25-1.78-.75l-5-5.02q-.5.2-1.01.3a6 6 0 0 1-1.09.1m0-2q.65 0 1.3-.2a4 4 0 0 0 1.18-.63l6.07 6.08q.13.12.34.11a.5.5 0 0 0 .33-.14.5.5 0 0 0 .13-.34.5.5 0 0 0-.12-.33l-6.08-6.05a3 3 0 0 0 .65-1.17q.2-.66.2-1.33 0-1.5-.96-2.62a4 4 0 0 0-2.39-1.33l1.85 1.85q.3.3.3.7t-.3.7l-3.2 3.2q-.3.3-.7.3a1 1 0 0 1-.7-.3L5.05 10.5q.23 1.42 1.34 2.38 1.11.97 2.61.97" />
  </svg>
)
export default SvgSettingsWrench
